<template>
  <el-select
      v-model="value"
      placeholder="Select language"
      @change="updateLocale">
    <el-option
        v-for="language in languages"
        :key="language.value"
        :label="language.label"
        :value="language.value" />
  </el-select>
</template>

<script>
import { createNamespacedHelpers as namespace } from "vuex";
const { mapGetters, mapActions } = namespace("ui");

export default {
  name: "LanguageSelector",
  data() {
    return {
      languages: [
        {
          value: "en",
          label: "English",
        },
        {
          value: "es",
          label: "Español",
        },
      ],
      value: "",
    };
  },
  computed: {
    ...mapGetters(["locale"]),
  },
  mounted() {
    this.value = this.locale;
  },
  methods: {
    ...mapActions(["setLocale"]),
    updateLocale() {
      this.setLocale(this.value).then((locale) => {
        this.$i18n.locale = locale;

        this.$message({
          type: "success",
          message: this.$t("common.language_updated"),
        });
      });
    },
  },
};
</script>

<style scoped></style>
